<div class="sc-chat-wrapper" role="region" [attr.aria-label]="'chatbot.title' | translate">
  <div class="sc-header">
    <div class="sc-header--title" aria-hidden="true">{{ 'chatbot.title' | translate }}?</div>
    <div class="sc-header--buttons">
      <button
        class="sc-header--button"
        (click)="close()"
        [attr.aria-label]="'chatbot.buttons.close' | translate"
        [title]="'chatbot.buttons.close' | translate"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>
  <div
    class="sc-messages"
    role="log"
    aria-live="polite"
    [attr.aria-label]="'chatbot.a11y.messagesRegion' | translate"
    [class.sc-text-small]="options.textSize === 'small'"
    [class.sc-text-normal]="options.textSize === 'normal'"
    [class.sc-text-large]="options.textSize === 'large'"
  >
    <div class="sc-message--headline" aria-hidden="true">{{ 'chatbot.headline' | translate }}</div>
    <div class="sc-message sc-message-assistant sc-welcome">
      <div class="sc-message--avatar" aria-hidden="true">
        <div class="sc-avatar"></div>
      </div>
      <div class="sc-message--content">
        <div class="sc-bubble">
          <span>{{ 'chatbot.welcome.text' | translate }}</span>
          <br /><br />
          <a class="sc-welcome--link" href="/data-privacy" target="_blank" rel="noopener noreferrer">{{
            'chatbot.welcome.privacyLinkText' | translate
          }}</a>
        </div>
      </div>
    </div>
    <div
      *ngFor="let m of messages"
      class="sc-message"
      [class.sc-message-user]="m.role === 'user'"
      [class.sc-message-assistant]="m.role === 'assistant'"
      [attr.aria-label]="
        m.role === 'user' ? ('chatbot.a11y.userMessage' | translate) : ('chatbot.a11y.assistantMessage' | translate)
      "
    >
      <div class="sc-message--avatar" aria-hidden="true">
        <div class="sc-avatar"></div>
      </div>
      <div class="sc-message--content">
        <div class="sc-bubble" [class.sc-pending]="m.pending" [class.sc-error]="m.error">
          <ng-container *ngIf="!m.pending; else pendingTemplate">
            <div class="sc-markdown" [innerHTML]="m.content | markdown"></div>
          </ng-container>
          <ng-template #pendingTemplate>
            <div class="sc-typing-indicator" role="status" [attr.aria-label]="'chatbot.a11y.typing' | translate">
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
            </div>
          </ng-template>
        </div>
        <div class="sc-meta" aria-hidden="true">{{ m.createdAt | date: 'HH:mm' }}</div>
      </div>
    </div>
  </div>
  <form
    (submit)="onSend($event)"
    class="sc-input-row"
    [class.sc-pending]="isPending"
    [attr.aria-label]="'chatbot.a11y.inputForm' | translate"
    [class.sc-text-small]="options.textSize === 'small'"
    [class.sc-text-normal]="options.textSize === 'normal'"
    [class.sc-text-large]="options.textSize === 'large'"
  >
    <div class="sc-input--textarea-wrapper">
      <textarea
        #messageInput
        name="message"
        [(ngModel)]="draft"
        required
        [attr.aria-label]="'chatbot.placeholder' | translate"
        [placeholder]="'chatbot.placeholder' | translate"
        autocomplete="off"
        rows="1"
        maxlength="1500"
        (input)="onInput($event)"
        (keydown)="onKeyDown($event)"
        [attr.aria-describedby]="'sc-char-count'"
        [style.font-size.px]="options.textSize === 'small' ? 12 : options.textSize === 'large' ? 16 : 14"
      ></textarea>
      <span
        id="sc-char-count"
        class="sc-input--char-count"
        aria-live="polite"
        [class.sc-near-limit]="draft.length >= 1350"
        >{{ draft.length }} / 1500</span
      >
    </div>
    <button
      type="button"
      class="sc-input--button-icon sc-reset-button"
      (click)="promptReset()"
      [disabled]="isPending"
      [attr.aria-label]="'chatbot.buttons.newConversation' | translate"
      [title]="'chatbot.buttons.newConversation' | translate"
    >
      <span aria-hidden="true">&#8635;</span>
    </button>
    <button
      *ngIf="false"
      type="button"
      class="sc-input--button-icon"
      (click)="openOptions()"
      [disabled]="isPending"
      [attr.aria-label]="'chatbot.buttons.options' | translate"
      [title]="'chatbot.buttons.options' | translate"
    >
      <span aria-hidden="true">&#8942;</span>
    </button>
    <button
      type="submit"
      class="sc-input--button-send"
      [disabled]="isPending || isInputEmpty()"
      [attr.aria-label]="'chatbot.buttons.send' | translate"
      [title]="'chatbot.buttons.send' | translate"
    >
      {{ 'chatbot.buttons.send' | translate }} <span aria-hidden="true">&#10148;</span>
    </button>
  </form>

  <div
    class="sc-overlay"
    *ngIf="showResetConfirmation"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="'chatbot.resetConfirmation.question' | translate"
  >
    <div class="sc-confirmation-box">
      <p>{{ 'chatbot.resetConfirmation.question' | translate }}</p>
      <div>
        <button
          class="btn btn-primary"
          (click)="confirmReset(true)"
          [attr.aria-label]="'chatbot.resetConfirmation.yes' | translate"
        >
          {{ 'chatbot.resetConfirmation.yes' | translate }}
        </button>
        <button
          class="btn btn-secondary"
          (click)="confirmReset(false)"
          [attr.aria-label]="'chatbot.resetConfirmation.no' | translate"
        >
          {{ 'chatbot.resetConfirmation.no' | translate }}
        </button>
      </div>
    </div>
  </div>

  <div
    class="sc-overlay"
    *ngIf="showCloseConfirmation"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="'chatbot.closeConfirmation.question' | translate"
  >
    <div class="sc-confirmation-box">
      <p>{{ 'chatbot.closeConfirmation.question' | translate }}</p>
      <!-- <div class="sc-confirmation-buttons"> -->
      <div>
        <button
          class="btn btn-primary"
          (click)="confirmClose(true)"
          [attr.aria-label]="'chatbot.closeConfirmation.yes' | translate"
        >
          {{ 'chatbot.closeConfirmation.yes' | translate }}
        </button>
        <button
          class="btn btn-secondary"
          (click)="confirmClose(false)"
          [attr.aria-label]="'chatbot.closeConfirmation.no' | translate"
        >
          {{ 'chatbot.closeConfirmation.no' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="sc-options-overlay"
  *ngIf="showOptions"
  role="dialog"
  aria-modal="true"
  [attr.aria-labelledby]="'sc-options-title'"
>
  <div class="sc-options-box">
    <div class="sc-options-header">
      <div id="sc-options-title">{{ 'chatbot.options.title' | translate }}</div>
      <button
        class="sc-options-close"
        (click)="closeOptions()"
        [attr.aria-label]="'chatbot.options.close' | translate"
        [title]="'chatbot.options.close' | translate"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="sc-options-content">
      <div class="sc-option-item">
        <label for="option-text-size">{{ 'chatbot.options.textSize.label' | translate }}</label>
        <select
          id="option-text-size"
          [(ngModel)]="options.textSize"
          [attr.aria-label]="'chatbot.options.textSize.label' | translate"
        >
          <option value="small">{{ 'chatbot.options.textSize.small' | translate }}</option>
          <option value="normal">{{ 'chatbot.options.textSize.normal' | translate }}</option>
          <option value="large">{{ 'chatbot.options.textSize.large' | translate }}</option>
        </select>
      </div>
      <div class="sc-option-item">
        <label for="option-send-with-enter">
          <input type="checkbox" id="option-send-with-enter" [(ngModel)]="options.sendWithEnter" />
          {{ 'chatbot.options.sendWithEnter' | translate }}
        </label>
      </div>
      <div class="sc-option-item sc-option-item--export">
        <label>{{ 'chatbot.options.export.label' | translate }}</label>
        <div class="sc-export-buttons" role="group" [attr.aria-label]="'chatbot.options.export.label' | translate">
          <button
            class="sc-export-btn"
            (click)="exportToClipboard()"
            [disabled]="messages.length === 0"
            [attr.aria-label]="'chatbot.options.export.clipboardTitle' | translate"
            [title]="'chatbot.options.export.clipboardTitle' | translate"
          >
            <svg
              aria-hidden="true"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <rect x="9" y="2" width="13" height="13" rx="2" />
              <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
            </svg>
            {{ 'chatbot.options.export.clipboard' | translate }}
          </button>
          <button
            class="sc-export-btn"
            (click)="exportToTxt()"
            [disabled]="messages.length === 0"
            [attr.aria-label]="'chatbot.options.export.txtTitle' | translate"
            [title]="'chatbot.options.export.txtTitle' | translate"
          >
            <svg
              aria-hidden="true"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
              <polyline points="14 2 14 8 20 8" />
              <line x1="16" y1="13" x2="8" y2="13" />
              <line x1="16" y1="17" x2="8" y2="17" />
              <polyline points="10 9 9 9 8 9" />
            </svg>
            {{ 'chatbot.options.export.txt' | translate }}
          </button>
        </div>
        <span class="sc-export-hint" role="status" aria-live="polite" *ngIf="exportCopied">{{
          'chatbot.options.export.copied' | translate
        }}</span>
        <span class="sc-export-hint sc-export-hint--error" role="alert" *ngIf="exportError">{{
          'chatbot.options.export.clipboardError' | translate
        }}</span>
      </div>
    </div>
    <div class="sc-options-footer">
      <button class="sc-options-save" (click)="closeOptions()" [attr.aria-label]="'chatbot.options.save' | translate">
        {{ 'chatbot.options.save' | translate }}
      </button>
    </div>
  </div>
</div>
